<div
  class="h-[100vh] flex items-center justify-center"
  style="background-color: var(--body-bg)"
>
  <div
    class="flex flex-col gap-4 p-8 bg-surface-0 border-surface-200 rounded shadow-lg"
  >
    <dt-signup-brand-logo></dt-signup-brand-logo>
    <router-outlet></router-outlet>
    <div class="h-8"></div>
    <dt-legal-notes></dt-legal-notes>
  </div>
</div>
